import React from "react";
import { MSelectCard } from "@/components/ui/atoms/MSelectCard";
import { useNavigate } from "react-router-dom";
import { getMemberInfo } from "@/hooks/useMembers";
import FormHeader from "@/components/ui/organisms/MHeader";

const InsuranceType: React.FC = () => {
  const navigate = useNavigate();
  const memberInfo = getMemberInfo();

  return (
    <div className="profile-page-root">
      <FormHeader
        module="Insurance"
        memberInfo={memberInfo}
        title={
          memberInfo.memberType === "p"
            ? `Does ${
                memberInfo.firstName || "your pet"
              } have health Insurance?`
            : "Health Insurance"
        }
        description="Choose the type of policy you’d like to store for easy access in Maatra."
        learnMoreContent="We store your insurance details securely so you can quickly find them in emergencies or for claims."
      />
      <div className="flex flex-col gap-6 mt-6">
        <MSelectCard
          leftIcon="ShieldCheck"
          text="Private Insurance"
          variant="description"
          description="A policy purchased directly from an insurance provider."
          onClick={() => {
            navigate("/profile/basic-information/insurance/type/form", {
              state: { insuranceType: "private" },
            });
          }}
          className="w-full"
        />
        <MSelectCard
          leftIcon="BuildingBank"
          text="Government Panel"
          variant="description"
          description="A government-provided health cover or panel scheme."
          onClick={() => {
            navigate("/profile/basic-information/insurance/type/form", {
              state: { insuranceType: "government" },
            });
          }}
          className="w-full"
        />
        <MSelectCard
          leftIcon="HomeShield"
          text="Link Family Policy"
          variant="description"
          description="Connect to a policy already added by a family member that also covers you."
          onClick={() =>
            navigate(
              `/profile/basic-information/insurance/type/link-family?memberId=${memberInfo.id}`
            )
          }
          className="w-full"
        />
      </div>
    </div>
  );
};

export default InsuranceType;
